import script from "./middleware.vue?vue&type=script&lang=js"
export * from "./middleware.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__